var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('impact-calculation-method'),_vm._v(" "),_c('asset-evaluation-propagation'),_vm._v(" "),_c('guarantor-primary-asset-creation'),_vm._v(" "),_c('guarantor-can-modify-declaration-of-applicability')],1)}
var staticRenderFns = []

export { render, staticRenderFns }